import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { Modal } from 'containers/misc'
import { Section, Title } from 'components/layout'
import { Button } from 'components/misc'

export default class AssessorResendConfirmationModal extends Component {
  static propTypes = {
    modalId: PropTypes.string.isRequired,
    modal: PropTypes.func.isRequired,
    isBecomeAssessor: PropTypes.bool,
    submitAction: PropTypes.func.isRequired,
    id: PropTypes.number.isRequired,
    orgId: PropTypes.number.isRequired,
    assessorPersonId: PropTypes.number.isRequired
  }

  static defaultProps = {
    data: {}
  }

  handleSubmit = (id, orgId, assessorPersonId) => {
    if (this.props.isBecomeAssessor) {
      this.props.submitAction(assessorPersonId, orgId, id)
    } else {
      this.props.submitAction(id)
    }
  }

  render() {
    const { modalId, id, orgId, assessorPersonId } = this.props

    return (
      <Modal id={modalId} customActions>
        <Section>
          <Title className="text--center" h2 intlKey="moduleTitle.are_you_sure">
            Are you sure?
          </Title>
          <div className="row">
            <div className="col-xs-6">
              <Button
                  secondary
                  onClick={() => this.props.modal(null)}
                  intlKey="button.close"
              >
                Close
              </Button>
            </div>
            <div className="col-xs-6 text--right">
              <Button
                  onClick={() => this.handleSubmit(id, orgId, assessorPersonId)}
                  intlKey="button.resend"
              >
                Resend
              </Button>
            </div>
          </div>
        </Section>
      </Modal>
    )
  }
}
